import dispatcher from '../dispatcher';

export function navigate(data) {
  return dispatcher.dispatch({
    type: 'NAVIGATE',
    data,
  });
}



// WEBPACK FOOTER //
// ./src/actions/route.js